import axios from 'axios'

export default {
    login: (email, password) => axios.post('login', {email: email, password: password}),
    validate: (data) => axios.get('validate', data),


    //new endpoints
    register: (data) => axios.post('register', data),
    verifyAccount: (data) => axios.post('verify-account', data),
    sendVerifyCode: (data) => axios.post('send-verify-code', data),
    recoverPassword: (data) => axios.post('recover-password', data),
    verifyRecoverCode: (data) => axios.post('verify-recover-code', data),
    newPassword: (data) => axios.post('new-password', data),
}